import { defineAction } from '~/prix'
import inventoryFetchAction from './inventoryFetch.action.json' with { type: 'json' }
import { inventoryObject } from '../inventoryObject'
import { z } from 'zod'

const inventoryFetchDefinition = defineAction({
  ...inventoryFetchAction,

  input: z.object({
    id: z.string().uuid(),
  }),
  output: inventoryObject,
})

export default inventoryFetchDefinition
